<template>
    <div>
        <v-toolbar color="primary">
            <v-toolbar-title class="ml-0 pl-3 white--text" style>
                <strong><span style="font-size:1.2rem;">{{certificationData.type}} certification</span></strong>
            </v-toolbar-title>
        </v-toolbar>
        <v-card class="elevation-1 pa-3">
            <v-card-text>
                <v-form ref="certificationForm">
                  <form-error-display-handler :errors="errors"></form-error-display-handler>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <header-text text="Personal information"
                                         icon="mdi-account"></header-text>
                        </v-flex>
                        <v-flex xs6>
                            <list-item-detail title="Full name" :sub_title="certificationData.name"></list-item-detail>
                        </v-flex>
                        <v-flex xs6 class="pl-2">
                            <list-item-detail title="Date of birth"
                                              :sub_title="certificationData.dob"></list-item-detail>
                        </v-flex>
                        <v-flex xs6>
                            <list-item-detail title="Gender" :sub_title="certificationData.gender"></list-item-detail>
                        </v-flex>
                        <v-flex xs6 class="pl-2">
                            <file-display :src="certificationData.user_image"></file-display>
                        </v-flex>
                        <v-flex xs6>
                            <list-item-detail title="Occupation"
                                              :sub_title="certificationData.gender"></list-item-detail>
                        </v-flex>

                        <v-flex xs6 class="pl-2">
                            <list-item-detail title="Contact number"
                                              :sub_title="certificationData.contact_number"></list-item-detail>

                        </v-flex>

                        <v-flex xs12>
                            <header-text text="Passport information"
                                         icon="mdi-passport">
                            </header-text>
                        </v-flex>

                        <v-flex xs6>
                            <list-item-detail title="Passport number"
                                              :sub_title="certificationData.passport_number"></list-item-detail>

                        </v-flex>
                        <v-flex xs6 class="pl-2">
                            <list-item-detail title="Passport validity"
                                              :sub_title="certificationData.passport_validity"></list-item-detail>

                        </v-flex>
                        <v-flex xs6>
                            <file-display
                                :src="certificationData.passport_image"
                            >
                            </file-display>
                        </v-flex>


                        <v-flex xs12>
                            <header-text :text="certificationData.type +' information'"
                                         icon="mdi-airplane-takeoff">
                            </header-text>
                        </v-flex>

                      <v-flex xs6>
                        <list-item-detail :title="certificationData.type + ' country ' "
                                          :sub_title="certificationData.country"></list-item-detail>
                      </v-flex>
                      <v-flex xs6>
                        <list-item-detail :title="certificationData.type + ' entry point ' "
                                          :sub_title="office"></list-item-detail>
                      </v-flex>
                        <v-flex xs6>
                            <list-item-detail :title="certificationData.type + ' date'"
                                              :sub_title="certificationData.date"></list-item-detail>

                        </v-flex>
                        <v-flex xs6 class="pl-2">
                            <list-item-detail title="Reason for certification "
                                              :sub_title="certificationData.reason_for_certification"></list-item-detail>

                        </v-flex>
                      <v-flex xs6>
                        <list-item-detail title="Purpose of visit "
                                          :sub_title="certificationData.purpose_of_visit"></list-item-detail>

                      </v-flex>

                        <v-flex xs6>
                            <file-display
                                :src="certificationData.passport_image"
                                v-if="certificationData.proof_of_departure"
                            >
                            </file-display>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="back"
                    :loading="loading"
                >Back
                </v-btn>
                <v-btn
                    color="primary"
                    @click="proceed"
                    :loading="loading"
                >Proceed
                </v-btn>
            </v-card-actions>
        </v-card>

    </div>
</template>

<script>
    import ListItemDetail from "../../components/ListItemDetail";
    import HeaderText from "../../components/HeaderText";
    import FileDisplay from "../../components/FileDisplay";
    import {API_URL, VERSION} from "../../config/config";
    import Http from "axios"
    import {buildFormData} from "../../helpers/formData";
    import FormErrorDisplayHandler from "@/components/FormErrorDisplayHandler";

    export default {
        name: "NonTouristCertificationConfirm",
        components: {
          FormErrorDisplayHandler,
            ListItemDetail,
            HeaderText,
            FileDisplay
        },
        props: ['certificationData'],
        data() {
            return {
                loading: false,
              errors:[]
            }
        },
      computed:{
        office() {
          let office = this.$store.state.Office.offices.find((i) => i.id === this.certificationData.office);
          return office.name;
        },
      },

        methods: {
            async proceed() {
                let formData = new FormData();
                buildFormData(formData, this.certificationData);
                try {
                    this.loading = true;
                    const response = await Http.post(API_URL + VERSION + '/non-visa-arrival-departure-certification', formData);
                    this.$emit('proceed', response.data);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    this.$store.commit('Notification/showError',e.response.data.message)
                  this.errors = e.response.data.errors;
                    throw e;
                }
            },
            back() {
                this.$emit('back')
            }
        }
    }
</script>
